import { render, staticRenderFns } from "./AssignActivities.vue?vue&type=template&id=71124979&"
import script from "./AssignActivities.vue?vue&type=script&lang=js&"
export * from "./AssignActivities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports